import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

// Externals
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import validate from 'validate.js';
import _ from 'underscore';

// Material helpers
import { withStyles } from '@material-ui/core/styles/index';

// Material components
import Grid from '@material-ui/core/Grid/index';
import Button from '@material-ui/core/Button/index';
import CircularProgress from '@material-ui/core/CircularProgress/index';
import TextField from '@material-ui/core/TextField/index';
import Typography from '@material-ui/core/Typography/index';
import Snackbar from '@material-ui/core/Snackbar';
import Divider from '@material-ui/core/Divider';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import HomeWorkOutlinedIcon from '@material-ui/icons/HomeWorkOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import base64 from 'react-native-base64'
import { v4 as uuidv4 } from 'uuid';

// Component styles
import styles from './styles';

// Form validation schema
import schema from './schema';
import { api_host, CLIENTE_ID_PICHINCHA } from '../../common/globals/constants';
import {getPass} from '../../services/getMail'
import { getClienteInfo } from '../../services/getClienteInfo';
import { Box } from '@material-ui/core';

import 'isomorphic-fetch';
import 'es6-promise';
import { Alert } from '@mui/material';
import { getQueryParams } from '../../utils/fns/get-query-params';
import { withTranslation } from 'react-i18next';
import { queryClient } from '../../App';

import {setRumUser} from '../../observability/rum';

// Service methods
const signIn = (email, pass) => {
    return new Promise(resolve => {
        setTimeout(() => {

            fetch(api_host+'/api-auth-reporte/', {
                method: 'POST', // or 'PUT'
                body: JSON.stringify({email: email,
                                    password: pass}), // data can be `string` or {object}!
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => res.json())
                .catch(error => console.error('Error:', error))
                .then(response => {
                    if (response.status == 1) {
                        sessionStorage.setItem('statusError', response.status)
                        resolve(false);
                    }else if (response.status == 5) {
                        sessionStorage.setItem('statusError', response.status)
                        resolve(false);
                    }else if (response.status == 6) {
                        sessionStorage.setItem('statusError', response.status)
                        resolve(false);
                    } else {
                        try {
                            sessionStorage.setItem('key', response.data.token)
                            sessionStorage.setItem('user', response.data.cliente_usuario_id)
                            sessionStorage.setItem('user_name', response.data.nombre_usuario)
                            sessionStorage.setItem('client_id', response.data.cliente_id)
                            sessionStorage.setItem('email', response.data.email)
                            sessionStorage.setItem('profile', response.data.perfil.nombre)
                            sessionStorage.setItem('profile_id', response.data.perfil.reporte_perfil_id)
                            sessionStorage.setItem('client_name', response.data.cliente.nombre)
                            sessionStorage.setItem('tz', response.data.zona_horaria.valor)
                            sessionStorage.setItem('period_semaphore', response.data.preferencia_semaforo_periodo)
                            sessionStorage.setItem('max_horariohabil', response.data.cliente.max_horariohabil)
                            sessionStorage.setItem('idioma_preferido', response.data.idioma_preferido)
                            sessionStorage.setItem('session_id', uuidv4())
                            sessionStorage.setItem('fechaLogin', new Date().getTime())
                            if (response.data.vista_compacta == null){
                                sessionStorage.setItem('extend_view', false)
                            } else { 
                                sessionStorage.setItem('extend_view', response.data.vista_compacta)
                            }
                            setRumUser({
                                id: response.data.cliente_usuario_id,
                                name: response.data.nombre_usuario,
                                email: response.data.email,
                            });
                            resolve(true);
                        } catch(err) {
                            sessionStorage.setItem('statusError', 100)
                            resolve(false);
                        }
                    }
                }
                );
        }, 100);
    });
};



class SignIn extends Component {
    constructor (props) {

        //Asignación de helper para prellenado de mail
        let token = window.location.search.split("=")[1] ? 
                    window.location.search.split("=")[0] === "?token" ? 
                        window.location.search.split("=")[1] : "" : "";
        let mail=""
        let password=""
        if(token!==""){
            token=atob(token).split(".atentus.")
            mail=token[0]
            password=atob(token[1])
        }
        sessionStorage.setItem('statusError', 0)
        super(props);   
        this.state = {
            values: {
                email: mail,
                password: password
            },
            touched: {
                email: false,
                password: false
            },
            errors: {
                email: null,
                password: null
            },
            isValid: false,
            isLoading: false,
            submitError: null,
            open: false,
            openModal:false,
            emailPass:"",
            colorCall:"",
            call:"",
            display:"none"
        };
    }
    componentDidMount(){
        const {values}=this.state
        if(values.email!=="" &&values.password!==""){
            this.handleSignIn()
        }
    }

    handleBack = () => {
        const { history } = this.props;

        history.goBack();
    };

    validateForm = _.debounce(() => {
        const { values } = this.state;

        const newState = { ...this.state };
        const errors = validate(values, schema);

        newState.errors = errors || {};
        newState.isValid = errors ? false : true;

        this.setState(newState);
    }, 300);

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };

        newState.submitError = null;
        newState.touched[field] = true;
        newState.values[field] = value;

        this.setState(newState, this.validateForm);
    };
    handleFieldChangeMail =(field, value)=>{
        //console.log(value)
        this.setState({emailPass:value});
    }

    handleSignIn = async () => {
        sessionStorage.clear()
        queryClient.clear()
        try {
            const { history } = this.props;
            const { values } = this.state;
            this.setState({ isLoading: true });
            await signIn(values.email, values.password);

            if (sessionStorage.length > 1) {
                // Ajusta idioma inicial según preferencia del backend
                try {
                    const { changeLanguage } = require('../../i18n');
                    const preferred = sessionStorage.getItem('idioma_preferido');
                    if (preferred && ['es', 'en', 'pt'].includes(preferred)) {
                        changeLanguage(preferred);
                    }
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.warn('No se pudo aplicar idioma_preferido tras login', e);
                }

                localStorage.setItem('isAuthenticated', true);

                // Verificar acceso a Métricas
                try {
                    const clienteInfo = await getClienteInfo();
                    sessionStorage.setItem('acceso_metricas', clienteInfo.autorizado === true);
                } catch (e) {
                    console.warn('No se pudo verificar acceso a Métricas', e);
                    sessionStorage.setItem('acceso_metricas', false);
                }
                // Verificar acceso a dashboard pichincha
                try {
                    const clienteInfo = await getClienteInfo(CLIENTE_ID_PICHINCHA);
                    sessionStorage.setItem('acceso_dashboard_pichincha', clienteInfo.autorizado === true);
                } catch (e) {
                    console.warn('No se pudo verificar acceso a Métricas', e);
                    sessionStorage.setItem('acceso_dashboard_pichincha', false);
                }

                history.push({ pathname: '/home', search: getQueryParams() });
            } else {
                this.setState({
                    isLoading: false,
                    isValid: false,
                    touched: {
                        email: false,
                        password: false,
                    },
                    open: true
                });
            }

        } catch (error) {
            this.setState({
                isLoading: false,
                serviceError: error,
                isValid: false,
                open: true
            });
        }
    };

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        this.setState({
            open: false 
        })
      };

    getSite=()=>{
        window.open('https://www.atentus.com', '_blank');
    }

    onOpenModal = () => {
        this.setState({
            openModal: true,
        });
    };

    onCloseModal = () => {
        this.setState({ openModal: false });
    };

    mailCheck=()=>{
        const { t } = this.props;
        var mail = this.state.emailPass;
        mail = base64.encode(mail);
        getPass(mail).then(value => {
            if (value == true) {
                this.setState({ colorCall: "#41B900", call: t('signin.modal.call.sent'), display: "inline" });
            } else {
                this.setState({ colorCall: "#C2272D", call: t('signin.modal.call.invalid'), display: "inline" });
            }
        })
    }

    render() {

    const { classes } = this.props;
    // safe fallback if t is not injected for any reason (prevents crash)
    const t = (this.props && typeof this.props.t === 'function') ? this.props.t : (key => key);
        const {
            values,
            touched,
            errors,
            isValid,
            submitError,
            isLoading,
            open,
            openModal,
            emailPass,
            display,
            call,
            colorCall
        } = this.state;
        const showEmailError = touched.email && errors.email;
        let status = sessionStorage.getItem('statusError')
        var statusMesagge = ''
        if (status == 1) {
            statusMesagge = t('signin.error.invalid')
        } else if (status == 5) {
            statusMesagge = t('signin.error.request_beta')
        } else if (status == 6) {
            statusMesagge = t('signin.error.expired')
        } else if (status == 100) {
            statusMesagge = t('signin.error.expired')
        }
        return (
                <Grid
                    className={classes.root}
                    container
                >
                    <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        alignItems="center"
                    >
                        <Grid>
                           <Tooltip title={t('signin.site.tooltip')} placement="left-end">
                                <Button style={{height:"50px"}} onClick={this.getSite}>
                                    <HomeWorkOutlinedIcon style={{fill:"white", height:"43px", width:"100px"}}/>  
                                </Button>
                            </Tooltip>
                        </Grid>

                    </Grid>
                    <Grid
                        item
                        lg={12}
                        xs={12}
                        xl={12}
                    >
                        <div style={{textAlign:"center", paddingTop:"5%"}}>
                            <Grid
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                                >
                                <Grid>
                                    <img
                                        alt={t('signin.logo.alt')}
                                        className={classes.logoImage}
                                        src="/images/logos/logo-atentus-gris.svg"
                                    />
                                  {/*   <Typography
                                        className={classes.titleLeft}
                                        variant="h1"
                                    >
                                        Atentus
                                        <img alt="" className={classes.titleImg} src={`favicon.ico`}/>
                                    </Typography> */}
                                </Grid>
                            </Grid>
                            <Grid style={{paddingTop:"20px"}}>
                                <Typography
                                    className={classes.textWhite}
                                    variant="h3"
                                >
                                    {t('signin.title')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} style={{paddingTop:"10px"}}>
                                <Grid
                                    container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                >
                                    <Grid>
                                        <div className={classes.divIcon}>
                                            <PersonOutlineOutlinedIcon  fontSize="large" className={classes.iconIn}/>
                                        </div>
                                    </Grid>
                                    <Grid>
                                        <TextField
                                            className={classes.textField}
                                            // label={t('signin.field.email')}
                                            name="email"
                                            onChange={event =>
                                                this.handleFieldChange('email', event.target.value)
                                            }
                                            type="text"
                                            value={values.email}
                                            variant="outlined"
                                            onKeyDown={event => {
                                                if (event.key === 'Enter') {
                                                    this.handleSignIn();
                                                }
                                            }}
                                        />
                                        </Grid>
                                </Grid>
                                
                            </Grid>
                            <Grid item xs={12} style={{paddingTop:"5px"}}>
                                
                                <Grid
                                    container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                >
                                    <Grid>
                                        <div className={classes.divIcon}>
                                            <LockOutlinedIcon  fontSize="large" className={classes.iconIn}/>
                                        </div>
                                    </Grid>
                                    <Grid>
                                        <TextField
                                            className={classes.textField}
                                            // label={t('signin.field.password')}
                                            name="password"
                                            onChange={event =>
                                                this.handleFieldChange('password', event.target.value)
                                            }
                                            type="password"
                                            value={values.password}
                                            variant="outlined"
                                            onKeyDown={event => {
                                                if (event.key === 'Enter') {
                                                    this.handleSignIn();
                                                }
                                            }}
                                        />
                                        
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} style={{paddingTop:"5px"}}>
                                <Button onClick={this.onOpenModal}>
                                    <Typography variant="caption" style={{color:"white"}}>{t('signin.forgot.password')}</Typography>
                                </Button>
                                <Modal
                                    
                                    aria-labelledby="simple-modal-title"
                                    aria-describedby="simple-modal-description"
                                    open={openModal}
                                    onClose={this.onCloseModal}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                    disableAutoFocus={true}
                                    disableEnforceFocus={true}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 500,
                                    }}
                                >                                    
                                    <Fade in={openModal}>
                                        <Grid style={{width:"500px", height:"283px", backgroundColor:"white", borderRadius: 10}}>
                                            <Grid
                                                container
                                                direction="row"
                                                justify="center"
                                                alignItems="center"
                                            >  
                                                <Grid item xs={12} xl={12} style={{textAlign:"center", borderTopRightRadius: 10, borderTopLeftRadius: 10}}>
                                                <img
                                                style={{height:"50px", marginTop: 10, marginBottom: 10}}
                                                        alt={t('signin.logo.alt')}
                                                        src="/images/logos/logo-atentus-azul.svg"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} xl={12} style={{paddingTop:"5px", textAlign:"center"}}>
                                                    <Typography variant="caption">
                                                        {t('signin.modal.forgot.description')}
                                                    </Typography>

                                                </Grid>
                                                <Grid item xs={12} xl={12} style={{paddingTop:"35px", textAlign:"center"}}>
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justify="center"
                                                        alignItems="center"
                                                    >
                                                        <Grid>
                                                            <TextField
                                                                className={classes.textField}
                                                                label={t('signin.modal.email.label')}
                                                                name="email"
                                                                onChange={event =>
                                                                    this.handleFieldChangeMail('email', event.target.value)
                                                                }
                                                                type="text"
                                                                value={emailPass}
                                                                variant="outlined"
                                                            
                                                            />
                                                            {showEmailError && (
                                                            <Typography
                                                                className={classes.fieldError}
                                                                variant="body2"
                                                            >
                                                                {t('signin.modal.email.invalid')}
                                                            </Typography>
                                                            )}
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                                <Grid item xs={12} xl={12} style={{paddingTop:"15px", textAlign:"center"}}>
                                                    <Button
                                                        style={{width:"257px", backgroundColor:"#FF7E00", color:"white"}}
                                                        
                                                        //disabled={!isValid}
                                                        onClick={this.mailCheck}
                                                        size="large"
                                                        variant="contained"
                                                    >
                                                        {t('signin.modal.button.continue')}
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={12} xl={12} style={{paddingTop:"15px", textAlign:"center", display:display}}>
                                                    <Typography style={{color:colorCall}}>{call}</Typography>
                                                </Grid>
                                            </Grid>                  
                                        </Grid>
                                    </Fade>
                                </Modal>
                            </Grid>
                            <Grid style={{paddingTop:"10px", paddingBottom:"40px"}}>
                            {submitError && (
                                <Typography
                                    className={classes.submitError}
                                    variant="body2"
                                >
                                    {submitError}
                                </Typography>
                            )}
                            {isLoading ? (
                                <CircularProgress className={classes.progress} />
                            ) : (
                                    <Button
                                        className={classes.signInButton}
                                        color="primary"
                                        disabled={!isValid}
                                        onClick={this.handleSignIn}
                                        size="large"
                                        variant="contained"
                                    >
                                        {t('signin.button.signin')}
                                    </Button>
                                )}
                            {isValid ? (
                                null
                            ) : (
                                <Snackbar
                                        anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                        }}
                                        open={open}
                                        autoHideDuration={5000}
                                        onClose={this.handleClose}
                                    >
                                        <Alert variant='filled' severity='error'>
                                            <Box display='flex'>
                                            {statusMesagge}
                                            </Box>
                                        </Alert>
                                </Snackbar>
                                
                                    
                            )}
                            </Grid>
                            <Grid
                                style={{paddingTop:"5px", paddingBottom:"40px"}}
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                                >
                                    <Divider  className={classes.textField} />
                            </Grid>
                            <Grid>
                                <Typography
                                    variant="caption"
                                    className={classes.textWhite}
                                    >
                                        {t('signin.help.contact')}
                                </Typography>
                            </Grid>
                            <Grid
                            style={{paddingTop:"10%"}}
                            container
                            direction="row"
                            alignItems="center"
                            >
                                <Grid item lg={3} md={3} xs={12}></Grid>
                                <Grid item lg={6} md={6} xs={12}>
                                    <Typography className={classes.sugestion} variant="h5">{t('signin.footer.rights')}</Typography>
                                </Grid>
                                <Grid container direction="row" alignItems="center" item lg={3} md={3} xs={12}>
                                    <Grid item lg={6} md={12} xs={6}>
                                        <img className={classes.imgLeftAppStore} src="/images/icono_appstore.svg" alt={t('signin.appstore.alt')}/>
                                        {/* <a href="https://itunes.apple.com/us/app/appmobile-atentus/id1326836795" target="_blank" rel='noopener noreferrer'>
                                        </a> */}
                                    </Grid>
                                    <Grid item lg={6} md={12} xs={6}>
                                        <img className={classes.imgLeftPlayStore} src="/images/icono_playstore.png" alt={t('signin.playstore.alt')}/>
                                        {/* <a href="https://play.google.com/store/apps/details?id=com.atentus.appmobileatentus&hl=es&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" target="_blank" rel='noopener noreferrer'>
                                        </a> */}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>                
                </Grid>
        );
    }
}

SignIn.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

SignIn.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    t: PropTypes.func
};


export default compose(
    withRouter,
    withTranslation(),
    withStyles(styles)
)(SignIn);
